import React from 'react';
import styled from 'styled-components';
import { getThemeColor } from '../../../utils/theme';

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 0px;
`;

const Icon = styled.svg`
  fill: none;
  stroke: ${getThemeColor(['red'])};
  stroke-width: 3px;
  margin-right: -4px;
  margin-top: -2px;
  padding-bottom: 2px;
`;

// Hide checkbox visually but remain accessible to screen readers.
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 13px;
  height: 13px;
  background: ${getThemeColor(['grayBlue'])};
  border: 0.5px solid ${getThemeColor(['greyVioletLight'])};
  border-radius: 3px;

  ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')}
  }
  
  &:hover {
    cursor: pointer;
  } 
`;

/*
* props
* checked
* onChange
* */
export const CheckBox = ({ className, checked, ...props }) => (
  <CheckboxContainer className={className}>
    <HiddenCheckbox checked={checked} {...props} />
    <StyledCheckbox checked={checked}>
      <Icon viewBox="0 0 24 24">
        <polyline points="18 4 7 16 4 10" />
      </Icon>
    </StyledCheckbox>
  </CheckboxContainer>
);
